import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBeneficiaries, getBeneficiariesByPage } from "../../helper/BackendHelper";


const BeneficiariesInitialLoad = createAsyncThunk(
    //action type string
    "beneficiaries/initial",
    // callback function
    async (data, thunkAPI) => {
        const response = await getBeneficiaries();
        if (response?.status === 500) {
            return thunkAPI.rejectWithValue("Server Error");
        } else {
            if (response?.data)
                return response.data;
        }
    }
);

const BeneficiariesPagination = createAsyncThunk(
    //action type string
    "beneficiaries/pagination",
    // callback function
    async (data, thunkAPI) => {
        const response = await getBeneficiariesByPage(data);
        if (response?.status === 500) {
            return thunkAPI.rejectWithValue("Server Error");
        } else {
            if (response?.data) {
                return response.data;
            }
        }
    }
);

export { BeneficiariesInitialLoad, BeneficiariesPagination }